import '../../style/App.css';
import { useEffect, useState} from 'react';
import GridMap from '../GridMap.js';
import { InfinitySpin } from 'react-loader-spinner';
import { useUser } from '../../../../../providers/UserProvider.js';

function getSocketOnType(string) {
    if (!string) return string; // Handle empty or null strings
    return 'sendImages' + string.charAt(0).toUpperCase() + string.slice(1);
}

const ImageDropdown = ({title, uploadedType, uploadedFiles, setUploadedFiles, handleClick, autoOpen=null, socket}) => {
    const [open, setOpen] = useState(null);
    const [loading, setLoading] = useState(null);
    const { username } = useUser();

    const getImages = () => {
        setOpen(true)
        setLoading(true)
        socket.emit("getImages", uploadedType, username);
        let socketOnType = getSocketOnType(uploadedType)
        socket.on(socketOnType, (images) => {
            let savedImages = [];
            images.forEach(image => {
                savedImages.push(image)
            })
            setUploadedFiles(savedImages.reverse())
            setLoading(false)
        });
    }

    const toggleOpenLoad = () => {
        // If null, first open
        if(open === null && uploadedFiles.length === 0) {
            getImages()
        } else { // else just open and close
            setOpen(!open)
        }
    }

    useEffect(() => {
        if(autoOpen) {
            toggleOpenLoad()
        }
    }, [])


    return (
        <div className='imageDropdownContainer'>
            <div className='imageDropdownTitleContainer' onClick={toggleOpenLoad} style={{}}>
                <div className='uploadedTitle'>Saved {title}</div> 
                <svg width="14" height="14" viewBox="0 0 14 14" style={{transform: open ? "rotate(90deg)" : "rotate(0deg)", transition: "transform 0.15s"}}>
                    <polyline points="4,3 9,7 4,11" fill="none" stroke="#822000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>

            {open && 
                <div className='imageDropdown'>
                    {loading ? (
                        <InfinitySpin visible={true} width="200" ariaLabel="infinity-spin-loading"/> 
                    ) : (
                        <> 
                            {uploadedFiles.length > 0 ? (
                                <GridMap imageArr={uploadedFiles} setImageArr={setUploadedFiles} handleClick={handleClick} socket={socket}/>
                            ) : (
                                <p>{'>'} No {title} found</p>
                            )}
                        </>
                    )}
                </div>
            }
        </div>
    );
};

export default ImageDropdown;